// extracted by mini-css-extract-plugin
module.exports = {"pointer":"styles-module__pointer___3t_2x"};